import styled from 'styled-components';

export interface IModalSubstrateProps {
  onClick: () => void;
}

export const ModalSubstrate = styled.div<IModalSubstrateProps>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
